import React, {Component} from 'react';
import {translate} from 'react-i18next';
import * as moment from 'moment';
import 'moment/locale/de';
import config from '../../../config/config.js';
import axios from 'axios';
import swal from 'sweetalert';

class ShiftComments extends Component {
    constructor(props) {
        super(props);

        this.state = {
            shiftId: 0,
            adding: false,
            editing: false,
            comments: [],
            commentsLoading: true,
            message: '',
            messageLoading: false,
            errors: []
        };

        this.handleDeleteComment = this.handleDeleteComment.bind(this);
        this.loadComments = this.loadComments.bind(this);
        this.handleAddComment = this.handleAddComment.bind(this);
        this.undoAddEditComment = this.undoAddEditComment.bind(this);
        this.handleChangeAddEditText = this.handleChangeAddEditText.bind(this);
        this.handleSaveAddEditComment = this.handleSaveAddEditComment.bind(this);
        this.handleSaveAddEditCommentByShortcut = this.handleSaveAddEditCommentByShortcut.bind(this);
    };

    componentWillMount() {
        this.setState({
            shiftId: this.props.shiftId
        });
    }

    componentDidMount() {
        this.loadComments();
    }

    loadComments() {
        let that = this;
        axios(config.server.endpoint + 'backend/shift/comments/' + this.state.shiftId, {
            method: 'get'
        }).then((response) => {
            if(response.status === 200) {
                that.setState({
                    comments: response.data,
                    commentsLoading: false
                });
            }
        })
    }

    handleDeleteComment(e) {
        const {t} = this.props;
        let commentId = e.currentTarget.value;

        swal({
            title: t('supporter.supporterComments.delete.really.title'),
            text: t('supporter.supporterComments.delete.really.text'),
            icon: 'warning',
            buttons: true,
            dangerMode: true
        }).then((reallyDo) => {
            if (reallyDo) {
                axios(config.server.endpoint + 'backend/shift/comment/' + this.state.shiftId + '/' + commentId, {
                    method: 'delete'
                }).then((response) => {
                    if(response.status === 200 && response.data.success === true) {
                        this.loadComments();
                    }
                })
            }
        })
    }

    handleAddComment() {
        this.setState({
            adding: true,
            message: ''
        })
    }

    undoAddEditComment() {
        this.setState({
            adding: false,
            editing: false,
            message: '',
            errors: []
        })
    }

    handleChangeAddEditText(e) {
        this.setState({
            message: e.target.value
        })
    }

    handleSaveAddEditComment() {
        this.setState({
            messageLoading: true
        });
        let that = this;
        axios(config.server.endpoint + 'backend/shift/comment/' + this.state.shiftId, {
            method: 'post',
            data: {
                message: this.state.message
            }
        }).then((response) => {
            if(response.status === 200) {
                if(response.data.success === true) {
                    that.setState({
                        messageLoading: false,
                        adding: false,
                        editing: false,
                        errors: []
                    });
                    that.props.reloadSchedule();
                    that.loadComments();
                } else {
                    that.setState({
                        messageLoading: false,
                        errors: response.data.errors
                    })
                }

            }
        })
    }

    handleSaveAddEditCommentByShortcut(e) {
        if ((e.ctrlKey || e.metaKey) && (e.charCode === 13 || e.charCode === 10)) {
            this.handleSaveAddEditComment()
        }
    }

    render() {
        const { t } = this.props;
        return (
            <div className="ShiftComments">
                <div className="hr-line-dashed"/>
                <div className="pull-right btn-group btn-group-xs">
                    <button type="button" onClick={this.handleAddComment}
                            className="btn btn-primary">
                        <i className="fa fa-plus"/>
                    </button>
                </div>
                <h4>
                    {this.state.commentsLoading ? (
                        <i className='fa fa-spinner fa-spin pull-right m-r-sm'/>
                    ) : null }
                    {t('shiftComments.title')}
                </h4>
                {this.state.adding || this.state.editing ? (
                    <div className="addEditBox">
                        <div className="">
                            <label>
                                {t('shiftComments.addEditMessage.label')}
                            </label>
                            <textarea autoFocus className="form-control" onChange={this.handleChangeAddEditText} readOnly={this.state.messageLoading} onKeyPress={this.handleSaveAddEditCommentByShortcut} value={this.state.message}/>
                            {(this.state.errors && this.state.errors.message) ? (
                                <span className="help-block text-danger">
                                            {t('shiftComments.message.error.' + this.state.errors.message)}
                                        </span>
                            ) : null}
                            <div className="text-right m-t-sm">
                                <a onClick={this.undoAddEditComment} className="btn btn-default m-r-xs" disabled={this.state.messageLoading}>
                                    <i className="fa fa-undo"/>
                                </a>
                                <button onClick={this.handleSaveAddEditComment} className="btn btn-primary"
                                        disabled={this.state.messageLoading}>
                                    {this.state.messageLoading ? (
                                        <i className='fa fa-spinner fa-spin inline-block m-r'/>
                                    ) : null}
                                    <i className="fa fa-save"/>
                                </button>
                            </div>
                        </div>
                    </div>
                ) : null }
                <ul className="list-group m-t">
                    {this.state.comments.map((comment, i) => (
                        <li className="list-group-item" key={i}>
                            <p>
                                <small className="pull-right text-muted">
                                    {moment(comment.createdAt).format('DD.MM.YYYY HH:mm')}
                                </small>
                                <span className="text-info block">
                                        {comment.createdBy.username}
                                    </span>
                            </p>
                            <p>
                                {comment.deleteableAndEditable ? (
                                    <button className="btn btn-circle pull-right" value={comment.id} onClick={this.handleDeleteComment}>
                                        <i className="fa fa-trash"/>
                                    </button>
                                ) : null }
                                {comment.message}
                            </p>
                        </li>
                    ))}
                </ul>
            </div>
        )
    }
}

export default translate()(ShiftComments);
